import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

import { IFRNotes, IFRNota } from '../../notes/notes.interfaces';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class NotesServiceContactes {
  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  private _API_BASE_URL: string = environment['API_URL'];

  public updateNota(data): Observable<any> {
    return this.authHttp.put(this._API_BASE_URL + 'notacontacte/'+data.id, data)
      .pipe(map(response => response || {}));
  }


  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id)
    .pipe(map(response => response || []));
  }
  
  constructor(private authHttp: HttpClient) { }

}
